// extracted by mini-css-extract-plugin
module.exports = {"module":"timer_module__S940-"};